import React from 'react';
import WaitingForDriver from '../views/delivery/waiting_for_driver.component';


const DeliveryInProgress = props => {

	return (
		<div className="waiting-ob">
			<WaitingForDriver history={props.history} />
		</div>
	)
}
export default DeliveryInProgress;
